import React, { useState } from "react";
import { FaPlusCircle, FaSync } from "react-icons/fa";
import TagForm from "./TagForm";
import { Row, Col, Button } from "react-bootstrap";
import axios from "axios";
import { notify } from "./notify";
import { logout } from "../actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import Message from "./Message";
import { CLINIC_DETAILS_RESET } from "../constants/clinicConstants";
import ClinicPatientTagForm from "./ClinicPatientTagForm";

const ClinicPatientTags = ({ patientTags, setPatientTags, clinicId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const dispatch = useDispatch();
  const updatePatientTags = async () => {
    // update
    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/clinics/${clinicId}/updatePatientTags`,
        {
          patientTags: patientTags.map((t) => {
            return {
              ...(t._id && { _id: t._id }), // Include only if _id
              label: t.label,
              isHide: t.isHide,
            };
          }),
        },
        config,
      );
      setPatientTags(
        data.updatedPatientTags && data.updatedPatientTags.length > 0
          ? data.updatedPatientTags
          : [
              {
                idx: Math.random(),
                label: "",
                isHide: false,
              },
            ],
      );
      setLoading(false);
      dispatch({ type: CLINIC_DETAILS_RESET });

      notify({
        title: "Patient Tags Update Status",
        message: <p className="lead">Data updated successfully.</p>,
        type: "success",
        duration: 4000,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
    }
  };

  const addPatientTag = () => {
    setPatientTags([
      ...patientTags,
      {
        idx: Math.random(),
        label: "",
        isHide: false,
      },
    ]);
  };

  return (
    <div>
      <h3>Patient History Items</h3>
      {loading ? (
        <Skeleton height="50px" count={3} />
      ) : error ? (
        <Message children={error} variant={`danger`} />
      ) : (
        <>
          {" "}
          {patientTags.map((t) => (
            <div key={t._id}>
              <ClinicPatientTagForm tag={t} />
            </div>
          ))}
          <Button
            className="btn-secondary w-100 my-3"
            onClick={() => addPatientTag()}
          >
            <FaPlusCircle className="ms-2" /> Add New Patient Tag
          </Button>
          {!loading && (
            <div className="d-flex justify-content-end mt-3 width-100">
              <div>
                <Button
                  variant="outline-info"
                  onClick={() => updatePatientTags()}
                >
                  <FaSync /> Update
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ClinicPatientTags;
